<template>
  <mdb-navbar light
              class = "navHeight sticky-top scrolling-navbar"> <!--  -->
    <mdb-navbar-brand>
      <router-link tag = "a"
                   to = "/">
        <img src = "@/assets/image/logo/divin.svg" alt = "DIVIN">
      </router-link>
    </mdb-navbar-brand>
    <mdb-navbar-toggler class = "toggles">
      <mdb-navbar-nav right>
        <router-link v-for = "link in links"
                     :key = "link.url"
                     tag = "mdb-nav-item"
                     active-class = "active"
                     :to = "link.url"
                     :exact = "link.exact"
                     class = "pNavTxt">
          {{ link.name }}
        </router-link>

      </mdb-navbar-nav>

    </mdb-navbar-toggler>
    <div class = "btnSale">
      <a class = "btn-floating"
         v-mdb-waves = "{ background: 'rgba(153,216,208,0.5)', center: true }"
         @click = "showModalShopping">
        <i class = "fas fa-shopping-bag"></i>
      </a>
      <span v-if = "saleCard.length" class = "counter">{{saleCard.length}}</span>
    </div>
    <ModalShopping :modalShopData = "modalShopData"
                   @hideModalShopping = "hideModalShopping"/>
  </mdb-navbar>
</template>

<script>
  import {mdbNavbar, mdbNavbarBrand, mdbNavbarNav, mdbNavbarToggler, mdbNavItem, mdbWaves} from "mdbvue";
  import {mapGetters} from 'vuex';
  import ModalShopping from '@/components/ModalShopping'

  export default {
    name: "NavBar",
    components: {
      mdbNavbar,
      mdbNavbarBrand,
      mdbNavbarToggler,
      mdbNavbarNav,
      mdbNavItem,
      ModalShopping
    },
    data: () => ({
      links: [
        {name: "каталог товаров", url: "/Catalog", exact: true},
        {name: "доставка и оплата", url: "/Delivery"},
        {name: "гарантии", url: "/Warranty"},
        {name: "контакты", url: "/Contact"}
      ],
      modalShopData: {relatedIn: false,}
    }),
    directives: {
      mdbWaves
    },
    computed: {
      ...mapGetters([
        'saleCard',
      ]),
    },

    mounted() {
      // Create a condition that targets viewports at least 768px wide

      const navBar = window.matchMedia("(min-width: 993px)");

      function navBarToggleHandleTabletChange(e) {
        // Check if the media query is true
        if (e.matches) {

          let toggleNavBar = document.getElementById('navbarSupportedContent');
          if (toggleNavBar.classList.contains('show-navbar')) {
            toggleNavBar.classList.remove('show-navbar');
            toggleNavBar.classList.add('hide-navbar');
            toggleNavBar.classList.add('collapse');
          }
        }
      }

      // Register event listener
      navBar.addListener(navBarToggleHandleTabletChange);

      // Initial check
      navBarToggleHandleTabletChange(navBar);
    },
    methods: {
      showModalShopping() {
        this.modalShopData.relatedIn = !!this.saleCard.length;
      },
      hideModalShopping(data) {
        this.modalShopData = data;
      },
    },
  };


</script>

<style lang = "scss">

</style>
